import React from "react"
import { optional } from "../../../utils/lang";

export default class ProgressBar extends React.Component {

    getValue() {
        const value = optional(this.props.value, 0);

        if (value < 0) {
            return 0
        } else if (value <= 100) {
            return value
        } else {
            return 100
        }
    }

    render() {
        const value = this.getValue(),
            width = value + "%";

        return(
            <div
                className="progress-bar__wrapper"
            >
                <div
                    style={{width: width}}
                    className="progress-bar__progress"
                />
                <div
                    className="progress-bar__background"
                />
            </div>
        )
    }
}